<div class="confirmation zoomIn show p-4" role="alertdialog" aria-modal="true"
  aria-describedby="globalDialogTitle globalDialogMsg" id="{{title}}attentiondialog">
  <div class="col-12">
    <h2 id="globalDialogTitle" class="font-bold confirmation-heading text-danger mb-3">Attention!</h2>
    <p id="globalDialogMsg" [innerHtml]="message"></p>
    <hr aria-hidden="true" tabindex="-1">
  </div>

  <div class="col-12 d-flex justify-content-center">
    <div class="col-auto p-0">
      <!-- for the no button -->
      <button *ngIf="!onlyOk" type="button" class="btn btn-danger px-4 mr-2" id="{{btnCancelText }}Btncd"
        (click)="decline()">{{btnCancelText }}</button>
      <br>
      <!-- dont remove this br. this is a hack for the accessibility -->
    </div>

    <div class="col-auto p-0">
      <!-- for the yes button -->
      <button type="button" id="{{ btnOkText }}Btncd" class="btn btn-primary px-4" (click)="accept()">
        <span *ngIf="!onlyOk">{{ btnOkText }}</span>
        <span *ngIf="onlyOk" id="OkBtncd">Ok</span>
      </button>
    </div>
  </div>
</div>
